import { createTheme } from "@mui/material/styles";
import { createContext, useMemo, useState } from "react";

// NOTE colors defined here match the Figma design, explanation here:
// https://www.notion.so/breeze-security/UI-UX-Process-c1866d47de8c4ee89cad4581aec9d148?pvs=4#b74ecbb7d28c4cd7a0dd4fec8966c46b
export const tokens = (mode) => ({
  // primary colors
  primary_lighter: "#4D82FE",
  primary_light: "#013DCA",
  primary_light_funnel: "rgb(158 200 254)",
  primary_light_label_text: "#4E8FE3",
  primary_opacity: "#1877F205",
  primary2: "rgba(24, 119, 242, 0.48)",
  primary_tab: "#0132A2",
  primary_main: "#0132A2",
  primary_25: "rgba(168, 199, 255, 1)",
  primary_50: "rgba(102, 156, 255, 1)",
  primary_100: "rgba(55, 125, 255, 1)",
  primary_150: "rgba(0, 84, 236, 1)",
  primary_200: "rgba(1, 61, 202, 1)",
  primary_300: "rgba(1, 50, 162, 1)",
  primary_300main: "#0132A2",
  primary_400: "#01277F",
  primary_500: "#011E60",

  primary_200_48percent: "rgba(1, 61, 202, 0.48)",
  primary_100_48percent: "rgba(55, 125, 255, 0.48)",
  primary_50_48percent: "rgba(102, 156, 255, 0.48)",
  primary_25_48percent: "rgba(168, 199, 255, 0.48)",
  secondary_100_48percent: "rgba(186, 236, 243, 0.48)",
  secondary_200_48percent: "rgba(120, 223, 237, 0.48)",
  secondary_300_48percent: "rgba(33, 199, 222, 0.48)",
  secondary_400_48percent: "rgba(25, 170, 189, 0.48)",
  dataviz_blue: "rgba(106, 163, 238, 1)",
  primary_gradient_modal: "rgba(197, 216, 251, 0.16)",

  primary_dark: "#01277F",
  primary_darker: "#011EB0",
  primary_2percent: "rgba(0, 84, 236, 0.02)",
  primary_4percent: "rgba(0, 84, 236, 0.04)",
  primary_6percent: "rgba(0, 84, 236, 0.06)",
  primary_8percent: "rgba(0, 84, 236, 0.08)",
  primary_12percent: "rgba(0, 84, 236, 0.12)",
  primary_16percent: "rgba(0, 84, 236, 0.16)",
  primary_20percent: "rgba(0, 84, 236, 0.20)",
  primary_24percent: "rgba(0, 84, 236, 0.24)",
  primary_32percent: "rgba(0, 84, 236, 0.32)",
  primary_48percent: "rgba(0, 84, 236, 0.48)",

  primary_soft_darker: "rgba(0, 84, 236, 0.16)",

  // secondary colors
  secondary_lighter: "#B4FBFF",
  secondary_light: "#A5FAFF",
  secondary_main: "#61E0E8",
  secondary_dark: "#1BB9CE",
  secondary_darker: "#008088",
  Secondary_soft_darker: "#179BA429",
  secondary_soft_label_fill: "rgba(139, 238, 245, 0.04)",
  secondary_8percent: "rgba(97, 224, 232, 0.08)",
  secondary_12percent: "rgba(97, 224, 232, 0.12)",
  secondary_16percent: "rgba(97, 224, 232, 0.16)",
  secondary_20percent: "rgba(97, 224, 232, 0.20)",
  secondary_24percent: "rgba(97, 224, 232, 0.24)",
  primary_button_hover_bg: "rgba(1, 50, 162, 0.29)",
  secondary_32percent: "rgba(97, 224, 232, 0.32)",
  secondary_48percent: "rgba(97, 224, 232, 0.48)",
  secondary_soft_light: "rgba(139, 238, 245, 0.08)",
  secondary_soft_darker: "rgba(23, 155, 164, 0.16)",

  secondary_100: "rgba(186, 236, 243, 1)",
  secondary_200: "rgba(120, 223, 237, 1)",
  secondary_300: "rgba(33, 199, 222, 1)",
  secondary_400: "rgba(25, 170, 189, 1)",
  secondary_500: "rgba(3, 129, 157, 1)",
  secondary_600: "rgba(0, 95, 116, 1)",

  // info colors
  info_lighter: "#DFD7FF",
  info_light: "#BAA8FF",
  info_main: "rgba(141, 112, 254, 1)",
  info_dark: "#5235C9",
  info_darker: "#471795",
  info_2percent: "rgba(141, 112, 254, 0.02)",
  info_8percent: "rgba(141, 112, 254, 0.08)",
  info_12percent: "rgba(141, 112, 254, 0.12)",
  info_16percent: "rgba(141, 112, 254, 0.16)",
  info_20percent: "rgba(141, 112, 254, 0.20)",
  info_24percent: "rgba(141, 112, 254, 0.24)",
  info_32percent: "rgba(141, 112, 254, 0.32)",
  info_48percent: "rgba(141, 112, 254, 0.48)",
  info_soft_ligth: "rgba(186, 168, 255, 0.08)",
  info_soft_dark: "rgba(51, 0, 255, 0.08)",
  info_soft_darker: "rgba(51, 0, 255, 0.16)",
  info_400: "#5604FB",
  // success colors
  success_soft: "#34CA820A",
  success_lighter: "#D3FCD2",
  success_light: "#4BE098",
  success_main: "#23C062",
  success_dark: "#118D57",
  light_green: "#93EA97",
  success_soft_label_text: "rgba(6, 172, 91, 1)",
  success_soft_label_fill: "rgba(52, 202, 130, 0.04)",
  success_darker: "#065E49",
  success_8percent: "rgba(34, 197, 94, 0.08)",
  success_12percent: "rgba(34, 197, 94, 0.12)",
  success_16percent: "rgba(34, 197, 94, 0.16)",
  success_20percent: "rgba(34, 197, 94, 0.20)",
  success_24percent: "rgba(34, 197, 94, 0.24)",
  success_32percent: "rgba(34, 197, 94, 0.32)",
  success_48percent: "rgba(34, 197, 94, 0.48)",
  success_soft_darker: "rgba(6, 94, 73, 0.16)",
  success_300_main: "rgba(49, 191, 123, 1)",
  success_400: "rgba(17, 141, 87, 1)",

  // warning colors
  warning_light_orange: "#FFD099",
  warning_orange_soft: "#FFB7260F",
  warning_yellow_soft: "#FDDF4A0A",
  warning_lighter: "#FFE49F",
  warning_light: "#FCD570",
  warning_main: "#FFB726",
  warning_dark: "#FF8A00",
  warning_darker: "#C86408",
  warning_8percent: "rgba(255, 171, 0, 0.08)",
  warning_12percent: "rgba(255, 171, 0, 0.12)",
  warning_16percent: "rgba(255, 171, 0, 0.16)",
  warning_20percent: "rgba(255, 171, 0, 0.20)",
  warning_24percent: "rgba(255, 171, 0, 0.24)",
  warning_32percent: "rgba(255, 171, 0, 0.32)",
  warning_48percent: "rgba(255, 171, 0, 0.48)",
  warning_soft_light: "rgba(252, 213, 112, 0.08)",
  warning_soft_darker: "rgba(255, 138, 0, 0.16)",
  warning_orange_300: "rgba(255, 138, 0, 1)",
  warning_orange_2: "rgba(254, 163, 57, 0.02)",
  warning_orange_8: "rgba(254, 163, 57, 0.08)",
  warning_orange_32: "rgba(254, 163, 57, 0.32)",
  warning_orange_70: "rgba(254, 163, 57, 0.70)",
  warning_yellow_300_main_yellow: "rgba(255, 171, 3, 1)",
  warning_yellow_200: "rgba(255, 200, 3, 1)",
  chip_favorites_enabled_bg: "rgba(255, 200, 3, 0.08)",
  warning_yellow_8percent: "rgba(255, 200, 3, 0.08)",
  // error colors
  red: "#FF9E95",
  error_lighter: "#FFD6D5",
  error_light: "#FFB1AF",
  error_soft: "#F007070A",
  error_light_label_text: "rgba(231, 61, 61, 1)",
  error_soft_label_fill: "rgba(243, 131, 127, 0.08)",
  error_light_darker: "#F3837F",
  error_main: "#F00707",
  error_dark: "#B71D18",
  error_darker: "#7E000F",
  error_4percent: "rgba(240, 7, 7, 0.04)",
  error_500: "#B71D18",
  error_400: "rgba(240, 7, 7, 1)",
  error_8percent: "rgba(240, 7, 7, 0.08)",
  error_12percent: "rgba(240, 7, 7, 0.12)",
  error_16percent: "rgba(240, 7, 7, 0.16)",
  error_20percent: "rgba(240, 7, 7, 0.20)",
  error_24percent: "rgba(240, 7, 7, 0.24)",
  error_32percent: "rgba(240, 7, 7, 0.32)",
  error_48percent: "rgba(240, 7, 7, 0.48)",
  error_soft_light: "rgba(255, 177, 175, 0.08)",
  error_soft_dark: "rgba(232, 13, 5, 0.16)",
  error_soft_darker: "#C8140E14",
  error_label_fill_gap: "rgba(243, 131, 127, 0.08)",
  error_box_shadow_color: "#96091A80",
  detections_bg: "rgba(255, 86, 48, 0.02)",
  // grey colors
  gray_main: "#919EAB",
  gray_soft: "#A2A2A2",
  grey_light: "#BEC7D0",
  grey_lighter: "#f6f7f8",
  grey_50: "#FDFDFD",
  grey_100: "#F9FAFB",
  grey_200: "#F4F6F8",
  grey_300: "#DFE3E8",
  grey_400: "#C4CDD5",
  grey_500: "#919EAB",
  grey_600: "#596773",
  grey_700: "#454F5B",
  grey_800: "#212B36",
  grey_900: "#161C24",
  grey_2percent: "rgba(145, 158, 171, 0.02)",
  grey_4percent: "rgba(145, 158, 171, 0.04)",
  grey_8percent: "rgba(145, 158, 171, 0.08)",
  grey_12percent: "rgba(145, 158, 171, 0.12)",
  grey_16percent: "rgba(145, 158, 171, 0.16)",
  grey_20percent: "rgba(145, 158, 171, 0.20)",
  grey_24percent: "rgba(145, 158, 171, 0.24)",
  grey_32percent: "rgba(145, 158, 171, 0.32)",
  grey_48percent: "rgba(145, 158, 171, 0.48)",
  //common colors
  common_black: "#141414",
  black_4percent: "rgba(0, 0, 0, 0.04)",
  black_8percent: "rgba(0, 0, 0, 0.08)",
  black_10percent: "rgba(0, 0, 0, 0.10)",
  black_12percent: "rgba(0, 0, 0, 0.12)",
  black_16percent: "rgba(0, 0, 0, 0.16)",
  black_24percent: "rgba(0, 0, 0, 0.24)",
  black_32percent: "rgba(0, 0, 0, 0.32)",
  black_48percent: "rgba(0, 0, 0, 0.48)",
  common_white: "#FFFFFF",
  white_8percent: "rgba(255, 255, 255, 0.08)",
  white_12percent: "rgba(255, 255, 255, 0.12)",
  white_16percent: "rgba(255, 255, 255, 0.16)",
  white_20percent: "rgba(255, 255, 255, 0.20)",
  white_24percent: "rgba(255, 255, 255, 0.24)",
  white_32percent: "rgba(255, 255, 255, 0.32)",
  white_48percent: "rgba(255, 255, 255, 0.48)",
  white_50percent: "rgba(255, 255, 255, 0.5)",
  white_0percent: "rgba(255, 255, 255, 0.00)",
  // text colors
  text_primary: "#212B36",
  text_secondary: "#454F5B",
  text_disabled: "#919EAB",
  text_selected: "#0132A2",
  text_help: "#919EAB",
  helper_text: "#919EAB",
  contrast_text_dark: "#212B36",
  contrast_text_light: "#FFFFFF",
  contrast_text_light_60percent: "rgba(255, 255, 255, 0.6)",
  coverage_bar: "#838A90",
  control_bar_upper_separator: "#677079",
  legend_separator: "#CBCBCB80",
  dashboard_card_shadow: "0px 0px 2px 1px rgba(203, 203, 203, 0.50)",
  rounded_tabs_shadow:
    "-3px -4px 5px 0.5px rgba(203, 203, 203, 0.40), 3px -4px 5px 0.5px rgba(203, 203, 203, 0.40)",
  custom_tooltip_text: "rgba(0, 0, 0, 0.87)",
  tooltip_info_icon: "rgba(145, 158, 171, 0.48)",
  scenario_involved_entity_button_hover: "rgba(0, 0, 0, 0.04)",
  scenario_involved_entity_button_click: "rgba(0, 0, 0, 0.12)",
  scenario_graph_background: "#919EAB05",
  scenario_graph_border: "#919EAB3D",
  // divider colors
  divider: "rgba(145, 158, 171, 0.2)",
  divider2: "rgba(203, 203, 203, 0.5)",
  // background colors
  background_default: "#fcfcfc",
  background_neutral: "#F4F6F8",
  // action colors
  action_active: "rgba(69, 79, 91, 1)",
  action_hover: "rgba(145, 158, 171, 0.08)",
  action_selected: "rgba(145, 158, 171, 0.16)",
  action_focus: "rgba(145, 158, 171, 0.24)",
  action_disabled: "rgba(145, 158, 171, 0.8)",
  action_disabled_bg: "rgba(145, 158, 171, 0.2)",
  // Threat Intel
  info16percentage: "rgba(141, 112, 254, 0.16)",
  info24percentage: "rgba(141, 112, 254, 0.24)",
  info_darker_8percentage: "rgba(51, 0, 255, 0.08)",
  priority_very_low_text: "rgba(1, 61, 202, 0.65)",
  priority_very_low_bg: "#919EAB14",
  priority_low_text: "#013DCA",
  priority_low_bg: "rgba(1, 50, 162, 0.12)",
  priority_medium_text: "rgba(1, 61, 202, 1)",
  priority_medium_bg: "rgba(0, 84, 236, 0.08)",
  primary_enabled_text: "#0132A2",

  priority_high_text: "rgba(1, 50, 162, 1)",
  priority_high_bg: "rgba(0, 84, 236, 0.12)",
  priority_critical_text: "rgba(1, 39, 127, 1)",
  priority_critical_bg: "rgba(0, 84, 236, 0.12)",
  //remediation - Feasibility
  feasibility_scanning_text: "#B9B9B9",
  feasibility_scanning_bg: "#F4F4F4",
  feasibility_very_low_text: "rgba(89, 103, 115, 1)",
  feasibility_very_low_bg: "rgba(145, 158, 171, 0.08)",
  feasibility_low_text: "#965900",
  feasibility_low_bg: "rgba(255, 200, 3, 0.12)",
  feasibility_medium_text: "rgba(200, 100, 8, 1)",
  feasibility_medium_bg: "rgba(255, 138, 0, 0.16)",
  feasibility_high_text: "rgba(17, 141, 87, 1)",
  feasibility_high_bg: "rgba(34, 197, 94, 0.16)",
  feasibility_very_high_text: "rgba(7, 101, 55, 1)",
  feasibility_very_high_bg: "rgba(17, 141, 87, 0.16)",
  // feasibility - remediation filter
  feasibility_very_low_stroke: "rgba(89, 103, 115, 1)",
  feasibility_very_low_fill: "rgba(145, 158, 171, 0.08)",
  feasibility_low_stroke: "rgba(255, 138, 0, 1)",
  feasibility_low_fill: "rgba(255, 200, 3, 0.2)",
  feasibility_medium_stroke: "rgba(200, 100, 8, 1)",
  feasibility_medium_fill: "rgba(255, 138, 0, 0.16)",
  feasibility_high_stroke: "rgba(17, 141, 87, 1)",
  feasibility_high_fill: "rgba(34, 197, 94, 0.16)",
  feasibility_very_high_stroke: "rgba(7, 101, 55, 1)",
  feasibility_very_high_fill: "rgba(17, 141, 87, 0.16)",

  very_low_text: "#637381",
  very_low_bg: "#919EAB29",
  //status - remediation
  status_resolve_text: "#118D57",
  status_resolve_bg: "#22C55E29",
  status_partially_resolved_text: "#5235C9",
  status_partially_resolved_bg: "#8D70FE29",
  status_pending_text: "#637381",
  status_pending_bg: "#919EAB29",
  modal_bg: "#FDFDFD",
  // status - auto remediation log
  auto_remediation_log_status_auto_resolved_dot: "#31BF7B",
  auto_remediation_log_status_partially_applied_dot: "#5604FB",
  auto_remediation_log_status_rolled_back_dot: "yellow",
  // risk status
  risk_minimal_text: "#118D57",
  risk_minimal_bg: "#22C55E29",
  risk_low_bg: "rgba(255, 205, 68, 0.16)",
  risk_low_text: "rgba(150, 89, 0, 1)",
  risk_medium_text: "rgba(195, 106, 1, 1)",
  risk_medium_bg: "rgba(238, 129, 0, 0.08)",
  risk_high_text: "#F00707",
  risk_high_bg: "#FF563014",
  risk_critical_text: "#B71D18",
  risk_critical_bg: "#C8140E14",

  // Custom colors
  // Topbar
  topbar_bg: "rgb(15, 84, 172)",
  // Sidebar
  sidebar_bg: "rgba(253, 253, 253, 1)",
  sidebar_selected_tab: "rgb(231, 239, 253)",

  // Threat Intel
  info_soft_light: "rgba(186, 168, 255, 0.08)",
  info_light_hover: "rgba(186, 168, 255, 0.16)",
  //wizard
  wizard_background_box: "rgba(255, 255, 255, 0.10)",
  wizard_box_shadow: "rgba(0, 84, 236, 0.10)",

  // Asset Card
  asset_card: "rgba(0, 84, 236, 0.9)",
  asset_card_hover: "rgba(0, 84, 236, 0.8)",
  asset_card_selected: "rgba(0, 84, 236, 0.5)",
  background_dialog: "#fff",
  card_box_show_suggested: "rgba(3, 67, 183, 0.50)",
  create_and_update_wizard_bg: "rgba(145, 158, 171, 0.02)",

  grey_dark: "#727685",
  snoozed_bg: "#61E0E814",
  gap_text: "#F56763",
  snoozed_text: "#24C2CC",
  compliant_text: "#118D57",
  dataGridBorder: "#d9d9d9",
  snoozed_status: "#19AABD",

  //vulnerability chart
  cve_low: "#FFE49F",
  cve_medium: "#FF8A0099",
  cve_high: "#F0070799",
  cve_critical: "#B71D18BF",

  //vulnerability funnel
  cve_funnel1: "rgba(0, 84, 236, 1)",
  cve_funnel2: "rgba(1, 61, 202, 1)",
  cve_funnel3: "rgba(1, 50, 162, 1)",

  // Environment
  selected_entity_card_box_shadow: "0px 0px 1px 0.5px rgba(3, 67, 183, 0.50)",
  entity_type_card_box_shadow: "0px 0px 2px 2px rgba(24, 119, 242, 0.1)",
  selected_entity_type_card_box_shadow:
    "0px 0px 3px 2px rgba(0, 84, 236, 0.3) inset",
  entity_type_sources_card_box_shadow:
    "0px 0.5px 1.5px 1.5px rgba(0, 0, 0, 0.08)",
  entity_type_overview_top_shadow: "0px 0px 1px 1px rgba(145, 158, 171, 0.18)",
  critical_asset_chip_enabled_fill: "#1877F205",
  critical_asset_chip_enabled_shadow: "0px 0px 2px 0px #1877F27A",
  chip_inventory_enabled_bg: "#FFFFFF",
  chip_inventory_enabled_shadow: "0px 0px 1px 0.5px rgba(0, 84, 236, 0.48)",
  chip_inventory_icon_color: "#0132A2",

  // MITRE
  mitre_red_fill: "rgba(240, 7, 7, 0.06)",
  mitre_red_label_text: "rgba(240, 7, 7, 1)",
  mitre_red_label_fill: "rgba(255, 86, 48, 0.16)",
  mitre_green_fill: "rgba(52, 202, 130, 0.08)",
  mitre_green_label_text: "rgba(7, 101, 55, 1)",
  mitre_green_label_fill: "rgba(34, 197, 94, 0.2)",
  mitre_orange_fill: "rgba(255, 200, 3, 0.08)",
  mitre_orange_label_text: "#965900",
  mitre_orange_label_fill: "rgba(255, 200, 3, 0.12)",
  mitre_yellow_fill: "rgba(255, 205, 76, 0.08)",
  mitre_yellow_label_text: "rgba(244, 164, 0, 1)",
  mitre_yellow_label_fill: "rgba(255, 171, 0, 0.16)",

  // Admin
  label_soft_admin_yellow: "rgba(254, 236, 190, 0.16)",
  label_admin_pink: "rgba(255, 177, 175, 0.08)",
  label_admin_green: "rgba(52, 202, 130, 0.08)",
  label_admin_red: "rgba(232, 13, 5, 0.08)",
  label_admin_teal: "rgba(97, 224, 232, 0.12)",
  label_admin_blue: "rgba(24, 119, 242, 0.08)",
  label_admin_purple: "rgba(141, 112, 254, 0.12)",
  label_admin_orange: "rgba(238, 129, 0, 0.12)",

  // Pie & Chart
  pie_green: "#769E86",
  pie_blue_grey: "#5F78A4",
  pie_purple_pink: "#BA78B7",
  pie_mustard: "#C79851",
  pie_pink: "#ED7A76",
  pie_mitigated: "#8AE3A3",
  pie_partially_mitigated: "#FFE79B",
  pie_not_mitigated: "#FFB1AF",
  pie_optimal_protection: "rgba(116, 226, 151, 1)",
  pie_partial_protection: "rgba(255, 236, 129, 1)",
  pie_detection_only: "rgba(255, 203, 98, 1)",
  pie_at_risk: "rgba(255, 148, 145, 1)",

  chart_blue: "#4E8FE3",
  chart_purple: "rgba(186, 168, 255, 0.5)",
  chart_green: "rgba(42, 226, 137, 0.5)",
  chart_red: "rgba(42, 226, 137, 0.5)",
  chart_teal: "rgba(97, 224, 232, 0.5)",
  chart_orange: "rgba(255, 138, 0, 0.5)",
  chart_yellow: "rgba(255, 138, 0, 0.5)",
  chart_pink: "rgba(255, 164, 161, 0.5)",
  box_shadow: "rgba(0, 0, 0, 0.25)",
  // Dropdown menu colors
  dropdown_menu_shadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.25)",

  // NIST Function
  nist_protect_main: "rgba(180, 180, 255, 0.45)",
  nist_detect_main: "rgba(255, 188, 88, 0.45)",
  nist_respond_main: "rgba(255, 124, 113, 0.45)",
  nist_recover_main: "rgba(110, 255, 169, 0.45)",
  nist_govern_main: "rgba(255, 240, 106, 0.45)",
  nist_identify_main: "rgba(124, 214, 255, 0.45)",
  nist_protect_stroke: "rgba(209, 209, 255, 1)",
  nist_detect_stroke: "rgba(255, 219, 163, 1)",
  nist_respond_stroke: "rgba(255, 198, 194, 1)",
  nist_recover_stroke: "rgba(168, 255, 204, 1)",
  nist_govern_stroke: "rgba(255, 244, 128, 1)",
  nist_identify_stroke: "rgba(189, 235, 255, 1)",

  //Tracking Status Inbar
  tracking_priority_highest: "rgba(201, 86, 82, 1)",
  tracking_priority_high: "rgba(246, 106, 106, 1)",
  tracking_priority_medium: "rgba(246, 164, 106, 1)",
  tracking_priority_low: "rgba(248, 198, 89, 1)",
  tracking_priority_lowest: "rgba(243, 214, 146, 1)",
  tracking_priority_triage: "rgba(145, 158, 171, 1)",

  tracking_backlog: "rgba(247, 151, 39, 1)",
  tracking_on_hold: "rgba(255, 212, 101, 1)",
  tracking_blocked: "rgba(238, 98, 93, 1)",
  tracking_done: "rgba(78, 165, 136, 1)",
  tracking_in_progress: "rgba(100, 77, 191, 1)",
  tracking_discarded: "rgba(120, 216, 222, 1)",

  //Tracking status jira
  jira_to_do: "#172B4D",
  jira_in_progress: "#0055CC",
  jira_done: "#1F845A",

  // Dig security labels
  // NOTE: these colors are from the Dig UI and should not be modified!
  dig_label_light_blue: "#6BAAFDB2",
  dig_label_purple: "#BAA8FFB2",
  dig_label_brown: "#E0B58DB2",
  dig_label_pink: "#F687ACB2",
  dig_label_turquoise: "#74D5CBB2",

  //Tracking Priority
  //vulnerability chart
  tracking_low: "#FFD465",
  tracking_medium: "#ff8a00c2",
  tracking_high: "#F0070799",
  tracking_critical: "#B71D18BF",

  // Entities Chip
  entity_chip_enabled_fill: "#F9FCFF",
  entity_chip_enabled_shadow: "0 0 2px 0 rgba(17, 161, 234, 0.48) inset",
  entity_chip_inventory_shadow: "0 0 2px 0 rgba(17, 161, 234, 0.24)",

  misconfig_chip_enabled_shadow: "#919EAB7A",

  // sidebar
  sidebar_box_shadow: "rgba(145, 158, 171, 0.05)",
  card_chart_box_shadow: "rgba(203, 203, 203, 0.50)",

  // operational heatmap
  ops_heatmap_blue_fill: "rgba(168, 199, 255, 1)",
  ops_heatmap_orange_fill: "rgba(255, 189, 112, 1)",
  ops_heatmap_green_fill: "rgba(153, 228, 192, 1)",
  ops_heatmap_red_fill: "rgba(255, 151, 151, 1)",
  ops_heatmap_yellow_fill: "rgba(255, 231, 114, 1)",

  ops_heatmap_low: "rgba(255, 148, 148, 1)",
  ops_heatmap_below_average: "rgba(255, 204, 152, 1)",
  ops_heatmap_medium: "rgba(255, 241, 168, 1)",
  ops_heatmap_above_average: "rgba(173, 238, 195, 1)",
  ops_heatmap_optimal: "rgba(98, 198, 155, 1)",
  ops_heatmap_not_applicable: "rgba(223, 227, 232, 1)",

  // Scrollbar
  scrollbar_thumb: "#C4CDD5",

  // TextField
  textfield_border: "#919EAB33",
  textfield_border_hover: "#DFE3E8",
  textfield_border_focus: "#DFE3E8",
  textfield_outlined_enabled_auto_generated_bg: "#F9FAFB",
  textfield_outlined_enabled_bg: "#FFFFFF",
  textfield_outlined_enabled_stroke: "#919EAB29",

  // Jira Modal colors
  jira_modal_bg: "#FDFDFD",

  // Buttons
  // text
  button_text_inherit_enabled_bg: "#FFFFFF00",
  button_text_inherit_enabled_text: "#596773",
  button_text_inherit_hovered_bg: "#919EAB14",
  button_text_primary_enabled_bg: "#FFFFFF00",
  button_text_primary_enabled_text: "#0132A2",
  button_text_primary_hovered_bg: "#0054EC0A",
  button_text_success_enabled_bg: "#FFFFFF00",
  button_text_success_enabled_text: "#118D57",
  button_text_success_hovered_bg: "rgba(52, 202, 130, 0.04)",
  button_text_error_enabled_bg: "#FFFFFF00",
  button_text_error_enabled_text: "#B71D18",
  button_text_error_hovered_bg: "rgba(240, 7, 7, 0.04)",
  button_text_disabled_text: "#C4CDD5",
  button_text_disabled_bg: "rgba(145, 158, 171, 0.08)",
  // contained
  button_contained_primary_enabled_bg: "#0132A2",
  button_contained_primary_enabled_text: "#FFFFFF",
  button_contained_primary_hovered_bg: "#01277F",
  button_contained_disabled_text: "#C4CDD5",
  button_contained_disabled_bg: "rgba(145, 158, 171, 0.20)",
  button_contained_success_enabled_text: "#FFFFFF",
  button_contained_success_enabled_bg: "#31BF7B",
  button_contained_success_hovered_bg: "#118D57",
  // outlined
  button_outlined_inherit_enabled_text: "#454F5B",
  button_outlined_inherit_enabled_bg: "#FFFFFF",
  button_outlined_inherit_enabled_stroke: "#DFE3E8",
  button_outlined_inherit_enabled_icon: "#454F5B",
  button_outlined_inherit_hovered_text: "#454F5B",
  button_outlined_inherit_hovered_bg: "rgba(145, 158, 171, 0.08)",
  button_outlined_inherit_hovered_stroke: "#919EAB",
  button_outlined_inherit_hovered_icon: "#454F5B",
  // note = - disabled colors a common to all outlined buttons (inherit, primary, etc..)
  button_outlined_disabled_text: "#C4CDD5",
  button_outlined_disabled_bg: "#FFFFFF",
  button_outlined_disabled_stroke: "#DFE3E8",
  button_outlined_disabled_icon: "#C4CDD5",
  // soft
  button_soft_primary_enabled_text: "#0132A2",
  button_soft_primary_enabled_bg: "rgba(0, 84, 236, 0.08)",
  button_soft_primary_enabled_icon: "#0132A2",
  button_soft_primary_hovered_text: "#0132A2",
  button_soft_primary_hovered_bg: "rgba(0, 84, 236, 0.16)",
  button_soft_disabled_text: "#C4CDD5",
  button_soft_disabled_bg: "rgba(145, 158, 171, 0.08))",
  button_soft_disabled_icon: "#C4CDD5",

  // IconButtons
  // outlined
  icon_button_inherit_enabled_bg: "#FFFFFF",
  icon_button_inherit_enabled_stroke: "#DFE3E8",
  icon_button_inherit_icon: "#454F5B",
  icon_button_inherit_hovered_bg: "rgba(145, 158, 171, 0.08)",
  icon_button_inherit_hovered_stroke: "#919EAB",
  icon_button_inherit_disabled_bg: "#FFFFFF",
  icon_button_inherit_disabled_stroke: "rgba(145, 158, 171, 0.20)",
  icon_button_inherit_disabled_icon: "rgba(145, 158, 171, 0.20)",
  // circular
  icon_button_circular_disabled_icon: "#C4CDD5",

  // tags
  // input
  tag_input_inherit_text: "#212B36",
  tag_input_error_text: "#F00707",
  tag_input_success_text: "#118D57",
  tag_input_warning_text: "#FF8A00",
  tag_input_overlay_text: "#454F5B",
  tag_input_inherit_bg: "rgba(255, 255, 255, 0.16)",
  tag_input_overlay_bg: "rgba(255, 255, 255, 0.16)",
  tag_stroke: "#DFE3E8",

  // Stroke
  enabled_stroke: "rgba(223, 227, 232, 1)",
  enabled_stroke_20: "rgba(145, 158, 171, 0.20)",
  text_field_standard_enabled_stroke: " #DFE3E8",
  icon_stroke: "rgba(145, 158, 171, 0.24)",
  timeline_stroke: "#C4CDD5",

  // Toggle buttons
  toggle_button_enabled_bg: "#FFFFFF",
  toggle_button_hovered_bg: "#919EAB14",
  toggle_button_selected_bg: "#0054EC14",
  toggle_button_focused_bg: "#919EAB52",

  // Rating
  rating_checked_enabled: "#0132A2",
  rating_unchecked_enabled: "#C4CDD5",

  // Tenant SLA Field
  severity_critical_hover: "#B71D18",
  severity_high_hover: "#FF7676",
  severity_medium_hover: "#FEA339",
  severity_low_hover: "#FEDF48",

  // Tenant Avatar
  tenant_avatar_bg_dark_green: "#4EA588",
  tenant_avatar_bg_light_green: "#93EA97",
  tenant_avatar_bg_red: "#FF9E95",
  tenant_avatar_bg_orange: "#FEC083",
  tenant_avatar_bg_yellow: "#FFE88A",
  tenant_avatar_bg_bluish_grey: "#5F78A4",
  tenant_avatar_bg_purple: "#BA78B7",
  tenant_avatar_bg_mustard: "#DDA551",
  tenant_avatar_bg_peach: "#ED7A76",
  tenant_avatar_bg_teal: "#4AE0E3",
  tenant_avatar_font_color_dark: "#000000",
  tenant_avatar_font_color_light: "#FFFFFF",

  icon_action_active: "#454F5B",
  icon_action_selected: "#0132A2",
  icon_action_disabled: "#C4CDD5",

  chip_primary_enabled_bg: "#0054EC0A",
  chip_enabled_bg: "#FFFFFF",
  chip_enabled_stroke: "rgba(145, 158, 171, 0.20)",
  chip_primary_text: "#0132A2",

  mssp_box_shadow_color: "rgba(203, 203, 203, 0.50)",

  radio_primary_checked_enabled: "#0132A2",
  icon_input_primary: "rgba(1, 50, 162, 1)",
  icon_input_success: "#31BF7B",

  // Alert
  alert_info_bg: "rgba(0, 84, 236, 0.04)",
  alert_info_stroke: "#70A3FF",

  // Asana
  asana_dark_red: "#E53B52",
  asana_dark_orange: "#F96237",
  asana_light_orange: "#FA9A27",
  asana_dark_brown: "#ECC42C",
  asana_light_green: "#A5CF3F",
  asana_dark_green: "#66D273",
  asana_light_teal: "#42C4AB",
  asana_dark_teal: "#32A9E8",
  asana_light_blue: "#4886DD",
  asana_dark_purple: "#7B6FED",
  asana_light_purple: "#A962E0",
  asana_light_pink: "#E163E1",
  asana_dark_pink: "#E84F9C",
  asana_light_red: "#FA91AE",
  asana_light_warm_gray: "#8DA3A6",

  // Text-Area
  text_area_outlined_enabled_value_bg: "#FDFDFD",
  text_area_outlined_hovered_bg: "#F9FAFB",
  text_area_outlined_enabled_stroke: "rgba(145, 158, 171, 0.20)",
  text_area_outlined_hovered_stroke: "#C4CDD5",

  //labels
  tag_label_1: "rgba(112, 163, 255, 1)",
  tag_label_2: "rgba(255, 148, 148, 1)",
  tag_label_3: "rgba(255, 204, 152, 1)",
  tag_label_4: "rgba(254, 223, 72, 1)",
  tag_label_5: "rgba(173, 238, 195, 1)",
  tag_label_6: "rgba(98, 198, 155, 1)",
  tag_label_7: "rgba(235, 165, 223, 1)",
  tag_label_8: "rgba(173, 153, 255, 1)",
  tag_label_9: "rgba(223, 227, 232, 1)",
  tag_label_10: "rgba(120, 223, 237, 1)",

  // Alerts
  alert_success_bg: "rgba(52, 202, 130, 0.04)",
  alert_success_border: "#31BF7B",
  alert_success_shadow: "#5DD59B",
});

// mui theme settings
export const themeSettings = (mode) => {
  const colors = tokens(mode);
  return {
    palette: {
      mode: mode,
      primary: {
        main: colors.text_primary,
      },
      secondary: {
        main: colors.secondary_main,
      },
      neutral: {
        dark: colors.grey_800,
        main: colors.grey_500,
        light: colors.grey_300,
      },
      background: {
        default: colors.background_default,
      },
    },
    // In order to change the font, you must first add it in a stylesheet inside frontend/public/index.html
    // see this video for more details: https://www.youtube.com/watch?v=lTGHf69T4l8&pp=ygUQbWF0ZXJpYWwgdWkgZm9udA%3D%3D
    typography: {
      fontFamily: ["Poppins", "sans-serif"].join(","),
      fontSize: 14,
      h1: {
        fontFamily: ["Poppins", "sans-serif"].join(","),
        fontSize: 64,
        fontWeight: 800,
      },
      h2: {
        fontFamily: ["Poppins", "sans-serif"].join(","),
        fontSize: 48,
        fontWeight: 800,
      },
      h3: {
        fontFamily: ["Poppins", "sans-serif"].join(","),
        fontSize: 32,
        fontWeight: 600,
      },
      h4: {
        fontFamily: ["Poppins", "sans-serif"].join(","),
        fontSize: 24,
        fontWeight: 600,
      },
      h5: {
        fontFamily: ["Poppins", "sans-serif"].join(","),
        fontSize: 20,
        fontWeight: 600,
      },
      h6: {
        fontFamily: ["Poppins", "sans-serif"].join(","),
        fontSize: 18,
        fontWeight: 600,
      },
      subtitle1: {
        fontFamily: ["Poppins", "sans-serif"].join(","),
        fontSize: 16,
        fontWeight: 600,
      },
      subtitle2: {
        fontFamily: ["Poppins", "sans-serif"].join(","),
        fontSize: 14,
        fontWeight: 500,
        lineHeight: "20px",
      },
      body1: {
        fontFamily: ["Poppins", "sans-serif"].join(","),
        fontSize: 16,
        fontWeight: 400,
      },
      body2: {
        fontFamily: ["Poppins", "sans-serif"].join(","),
        fontSize: 14,
        fontWeight: 400,
      },
      caption: {
        fontFamily: ["Poppins", "sans-serif"].join(","),
        fontSize: 12,
        fontWeight: 400, // Regular
        textTransform: "none",
        letterSpacing: "normal",
        lineHeight: "normal",
      },
      overline: {
        fontFamily: ["Poppins", "sans-serif"].join(","),
        fontSize: 12,
        fontWeight: 500,
        textTransform: "none",
        letterSpacing: "normal",
        lineHeight: "normal",
      },
      smallCaption: {
        fontFamily: ["Poppins", "sans-serif"].join(","),
        fontSize: 10,
        fontWeight: 400,
        textTransform: "none",
        letterSpacing: "normal",
        lineHeight: "normal",
      },
    },
  };
};

// context for color mode
export const ColorModeContext = createContext({
  toggleColorMode: () => {},
});

export const useMode = () => {
  const [mode, setMode] = useState("light");

  const colorMode = useMemo(
    () => ({
      toggleColorMode: () =>
        setMode((prev) => (prev === "light" ? "dark" : "light")),
    }),
    []
  );

  const theme = useMemo(() => createTheme(themeSettings(mode)), [mode]);
  return [theme, colorMode];
};
